import useProfileBaseActions from './useProfileBaseActions'

export default useProfileBaseActions
